<template>
    <div data-cy="container_modal_master">
        <AlertModal :controller="controller.alertModal" ></AlertModal>
        <ConfirmModal :controller="controller.confirmModal"></ConfirmModal>
        <LoadingModal :controller="controller.loadingModal"></LoadingModal>
        <ErrorModal :controller="controller.errorModal"></ErrorModal>
        <ConfirmRedeemModal :controller="controller.confirmRedeemModal"></ConfirmRedeemModal>
        <SerialModal :controller="controller.serialModal"></SerialModal>
        <DrawDeliveryModal :controller="controller.drawDeliveryModal"></DrawDeliveryModal>
        <ShippingAddressModal :controller="controller.shippingAddressModal"></ShippingAddressModal>
        <CopySerialSuccessModal :controller="controller.copySerialSuccessModal"></CopySerialSuccessModal>
        <VerifyCodeModal :controller="controller.verifyCodeModal"></VerifyCodeModal>
        <AddAddressModal :controller="controller.addAddressModal"></AddAddressModal>
        <EditAddressModal :controller="controller.editAddressModal"></EditAddressModal>
        <ListAddressModal :controller="controller.listAddressModal"></ListAddressModal>
        <AddTaxAddressModal :controller="controller.addTaxAddressModal"></AddTaxAddressModal>
        <EditTaxAddressModal :controller="controller.editTaxAddressModal"></EditTaxAddressModal>
        <ListTaxAddressModal :controller="controller.listTaxAddressModal"></ListTaxAddressModal>
        <OtpModal :controller="controller.otpModal"></OtpModal>
        <RegisterSuccessModal :controller="controller.registerSuccessModal"></RegisterSuccessModal>
        <MarketingOptionModal :controller="controller.marketingOptionModal"></MarketingOptionModal>
        <NoInternetModal :controller="controller.noInternetModal"></NoInternetModal>
        <DeliveryStatusModal :controller="controller.deliveryStatusModal"></DeliveryStatusModal>
        <CopySuccessModal :controller="controller.copySuccessModal"></CopySuccessModal>
        <FreeStarbuckModal :controller="controller.freeStarbuckModal"></FreeStarbuckModal>
        <MissionAlertModal :controller="controller.missionAlertModal"></MissionAlertModal>
        <MissionConfirmModal :controller="controller.missionConfirmModal"></MissionConfirmModal>
    </div>
</template>
<script>
//generic
import AlertModal from './Generic/AlertModal/AlertModal.vue';
import ConfirmModal from "./Generic/ConfirmModal/ConfirmModal.vue";
import LoadingModal from './Generic/LoadingModal/LoadingModal.vue';
import NoInternetModal from './Generic/NoInternetModal/NoInternetModal.vue';
import ErrorModal from './Generic/ErrorModal/ErrorModal.vue';
//redeem
import ConfirmRedeemModal from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModal.vue';
import SerialModal from '@/module/Detail/modal/SerialModal/SerialModal.vue';
import DrawDeliveryModal from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModal.vue';
import ShippingAddressModal from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModal.vue';
import CopySerialSuccessModal from '@/module/Detail/modal/SerialModal/CopySerialSuccessModal.vue';
import VerifyCodeModal from '@/module/Detail/modal/VerifyCodeModal/VerifyCodeModal.vue';
//address
import AddAddressModal from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModal.vue';
import EditAddressModal from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModal.vue';
import ListAddressModal from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModal.vue';
import AddTaxAddressModal from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModal.vue';
import EditTaxAddressModal from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModal.vue';
import ListTaxAddressModal from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModal.vue';
//Other core modal
import OtpModal from './Otp/OtpModal.vue';
import RegisterSuccessModal from '@/module/Register/modal/RegisterSuccessModal/RegisterSuccessModal.vue';
import MarketingOptionModal from './Terms/MarketingOptionModal/MarketingOptionModal.vue';
//history
import DeliveryStatusModal from '@/module/History/modal/DeliveryStatusModal/DeliveryStatusModal.vue';
import CopySuccessModal from '@/module/History/modal/CopyCodeModal/CopySuccessModal.vue';
import FreeStarbuckModal from '@/module/History/modal/FreeStarbuckModal/FreeStarbuckModal.vue';
//mission
import MissionAlertModal from '@/module/Mission/modal/MissionAlertModal/MissionAlertModal.vue';
import MissionConfirmModal from '@/module/Mission/modal/MissionConfirmModal/MissionConfirmModal.vue';

export default {
    name: 'ModalMaster',
    components: {
        AlertModal,
        ConfirmModal,
        LoadingModal,
        NoInternetModal,
        ErrorModal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        CopySerialSuccessModal,
        VerifyCodeModal,
        DrawDeliveryModal,
        AddAddressModal,
        EditAddressModal,
        ListAddressModal,
        AddTaxAddressModal,
        EditTaxAddressModal,
        ListTaxAddressModal,
        OtpModal,
        RegisterSuccessModal,
        MarketingOptionModal,
        DeliveryStatusModal,
        CopySuccessModal,
        FreeStarbuckModal,
        MissionAlertModal,
        MissionConfirmModal
    },
    props: {
        controller: {
            type: Object,
            required: true,
        },
    },
}
</script>
